import React, { Component, createRef } from 'react';
import { List, Grid, Button, Icon, Image } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
// import fuzzysort from 'fuzzysort';
import axios from 'axios';
import { API_URL } from '../App.js';
// import { YugtunLoader, WordItem, TagColors } from './HomeHelper.js';
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
import { sanitize } from 'dompurify';
// import {categories} from './constants/categories.js';
// import {categoriesUrlLookup} from './constants/categoriesUrlLookup.js';
import Citation from './Citation.js'

import * as Scroll from 'react-scroll';
// import { Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import ReactGA from "react-ga4";
ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;


let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
}


class NewPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
      activeAudioIndex: {},
      currentPage:decodeURI(props.match.params.word),
      copyClicked:false,
		}
		this.handleRef = createRef()
    scroll.scrollTo(0)
    // if (props.location.state !== undefined && 'history' in props.location.state) {
    //   scroll.scrollTo(props.location.state.history[2]);
    // }
	}

  componentDidMount() {
    // const categoriesDisplayed = [];
    // for (var key of Object.keys(categories)) {
    //   if (!key.includes(".")) {
    //     categoriesDisplayed.push(key)
    //   }   
    // }
    // const queryParameters = new URLSearchParams(window.location.search)
    // const category = queryParameters.get("category")
    // if (category !== null) {
    //   this.setState({activeTabIndex:3, homeMode:3, tabValue:3})
    //   if (category in categoriesUrlLookup) {
    //     this.setState({currentCategory:categoriesUrlLookup[category] })
    //     this.retrieveFamilyCategories(categoriesUrlLookup[category])
    //   } else {
    //     this.props.history.push('/?category=all')
    //   }      
    // }
    // this.setState({ categoriesDisplayed: categoriesDisplayed });

    // console.log(this.props.audioSearchList)
    // console.log(this.props.audiolibrary)
    // this.setState({combinedAudio:[...this.props.audioSearchList,...this.props.audiolibrary]})
    // this.setState({combinedAudio:this.props.audiolibrary})
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentPage !== prevState.currentPage) {
      this.setState({copyClicked:false})
    }
    // if (this.state.currentCategory !== 'all' && this.state.wordsList.length == 0 && categories[this.state.currentCategory].links.length>0) {
    //   this.retrieveFamilyCategories(this.state.currentCategory)
    //   scroll.scrollTo(0);
    // }

    // if (this.state.useExample !== prevState.useExample || this.state.useConversational !== prevState.useConversational || this.state.usePhrasebook !== prevState.usePhrasebook) {
    //   this.onChangeSearch(true, 2, null,this.state.search)
    // }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll)
  }

  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop

    this.setState({
      Yposition: winScroll,
    })
  }


  repeatAudio(audio, event, data) {

    if (!this.state.playingAudio) {

      let sound = new Audio(API_URL + "/aijaudiolibrary/" + audio);
      this.setState({playingAudio: true});

      sound.play()

      sound.onended=()=>{
        this.setState({playingAudio: false});
      }
    }
  }

  // soundDone = () => {
  //   console.log('done!')
  // }

  setActiveAudioIndex = (word, index) => {
    // console.log(word, index)
    let activeAudioIndex = this.state.activeAudioIndex
    if (index in activeAudioIndex) {
      delete activeAudioIndex[index]
      this.setState({activeAudioIndex:activeAudioIndex})
    } else {
      activeAudioIndex[index] = ""
      this.setState({activeAudioIndex:activeAudioIndex})

    }
    // console.log(activeAudioIndex)
    // this.setState({activeAudioIndex:activeAudioIndex})
  }



 

	render() {
    // console.log(this.props)
		let isCommon = false
    // let displayList = (this.state.search.length >= 2 && this.state.wordsList.length > 0) || (this.state.homeMode === 3 && this.state.wordsList.length > 0);
    let wordsList = this.state.wordsList;
    // let emptyList = this.state.search.length >= 2 && this.state.wordsList.length === 0 && this.state.activeTabIndex !== 3;
    let categoryMargin = '4px'
    let previewCharLimit = 100
    let dopreview = false
    let paddingtext = 15
		return (
			<div className="app" style={{fontFamily:customFontFam}}>
      <Grid textAlign='center'>
      <Grid.Row>
      <Grid.Column style={{ maxWidth: 800 }} textAlign='left'>

            <Link to={{pathname: "/appendix"}} >
              <Button basic style={{paddingLeft:'10px',paddingRight:'15px',marginBottom:'3px'}} icon='left chevron' content='Back to List of Appendices' />
            </Link>

            {this.props.resourceIDs[this.state.currentPage][2][0].length > 0 ?
              <div style={{paddingTop:'23px',}}>
                <div style={{fontFamily:customTitleFontFam,paddingBottom:16,fontSize:'18px',fontWeight:'700'}}>
                  <span>{this.props.resourceIDs[this.state.currentPage][0][0]+':'}</span>
                    {'r'+this.state.currentPage+'_e1' in this.props.audioFiles && !this.props.printView ?
                      <Icon onClick={()=>this.repeatAudio('r'+this.state.currentPage+'_e1')} circular style={{marginLeft:'10px',fontSize:'14px',color:'#969696',cursor:'pointer'}} name='volume up' />
                      :
                      null
                    }
                </div>
                <div style={{fontSize:'15px', fontWeight:400,marginBottom:17,}}>
                  <span>{this.props.resourceIDs[this.state.currentPage][2][0]}</span>
                </div>
                {'r'+this.state.currentPage+'_e2' in this.props.audioFiles && !this.props.printView ?
                  <div style={{textAlign:'center',paddingBottom:15}}>
                    <audio controls style={{width:(window.innerWidth < 480 ? '100%':'50%'),height:40}} src={API_URL + "/aijaudiolibrary/"+'r'+this.state.currentPage+'_e2'} />
                  </div>
                  :
                  null
                }
                {this.props.resourceIDs[this.state.currentPage][1][0].length > 0 ?
                  <div>
                  <div style={{fontFamily:customTitleFontFam,paddingBottom:16,fontSize:'18px',fontWeight:'700'}}>
                    <span>{this.props.resourceIDs[this.state.currentPage][1][0]+':'}</span>
                      {'r'+this.state.currentPage+'_y1' in this.props.audioFiles && !this.props.printView ?
                        <Icon onClick={()=>this.repeatAudio('r'+this.state.currentPage+'_y1')} circular style={{marginLeft:'10px',fontSize:'14px',color:'#969696',cursor:'pointer'}} name='volume up' />
                        :
                        null
                      }
                  </div>
                  <div style={{fontSize:'15px', fontWeight:400,marginBottom:17,}}>
                    <span>{this.props.resourceIDs[this.state.currentPage][3][0]}</span>
                  </div>
                    {'r'+this.state.currentPage+'_y2' in this.props.audioFiles && !this.props.printView ?
                    <div style={{textAlign:'center',paddingBottom:15}}>
                        <audio controls style={{width:(window.innerWidth < 480 ? '100%':'50%'),marginBottom:15,height:40}} src={API_URL + "/aijaudiolibrary/"+'r'+this.state.currentPage+'_y2'} />
                      </div>
                      :
                      <div style={{height:10}} />
                    }
                  </div>
                  :
                  <div style={{height:10}} />
                }
              </div>              
              :
              <div>
                <div style={{fontFamily:customTitleFontFam,paddingTop:'23px',paddingBottom:'10px',fontSize:'18px',fontWeight:'700'}}>
                  <div style={{marginBottom:'14px',}}>
                  <span>{this.props.resourceIDs[this.state.currentPage][0][0]+':'}</span>
                    {'r'+this.state.currentPage+'_e1' in this.props.audioFiles && !this.props.printView ?
                      <Icon onClick={()=>this.repeatAudio('r'+this.state.currentPage+'_e1')} circular style={{marginLeft:'10px',fontSize:'14px',color:'#969696',cursor:'pointer'}} name='volume up' />
                      :
                      null
                    }
                  </div>
                  <div>
                  <span>{this.props.resourceIDs[this.state.currentPage][1][0]+':'}</span>
                    {'r'+this.state.currentPage+'_y1' in this.props.audioFiles && !this.props.printView ?
                      <Icon onClick={()=>this.repeatAudio('r'+this.state.currentPage+'_y1')} circular style={{marginLeft:'10px',fontSize:'14px',color:'#969696',cursor:'pointer'}} name='volume up' />
                      :
                      null
                    }
                  </div>
                </div>
              </div>
            }
            <div style={{padding:14,marginTop:'20px'}}>
              <Grid style={{backgroundColor:'#8c75a0',color:'white',fontWeight:'600',fontSize:'16px'}}>
              <Grid.Row columns={2}>
              <Grid.Column>
                <div>
                  <span>{"English"}</span>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div>
                  <span>{"Yugtun"}</span>
                </div>
              </Grid.Column>
              </Grid.Row>
              </Grid>

              {this.props.IDsInResources[this.state.currentPage].map((id, index) => 
						    {
                  let word = this.props.masterKeyDict[id]
                return <Grid style={{fontSize:(window.innerWidth < 480 ? '14px' : '16px'),wordWrap:'break-word',backgroundColor:(index%2 == 1 ? '#F9F9F9' : 'white')}} key={id}>
                  <Grid.Row style={{fontWeight:500}} columns={2}>
                    <Grid.Column style={{padding:(window.innerWidth < 480 ? '0rem 0.5rem' : '0rem 1rem')}}>
				          		<div> 
                        <span dangerouslySetInnerHTML={{ __html: word.eTerm }} />
                        {'m'+id+'_e1' in this.props.audioFiles && !this.props.printView ?
                          <Icon onClick={()=>this.repeatAudio('m'+id+'_e1')} circular style={{marginLeft:'10px',fontSize:(window.innerWidth < 480 ? '12px' : '14px'),color:'#969696',cursor:'pointer'}} name='volume up' />
                          :
                          null
                        }
                      </div>
                    </Grid.Column>
                    <Grid.Column style={{padding:(window.innerWidth < 480 ? '0rem 0.5rem' : '0rem 1rem')}}>
                      <div>
                          <span dangerouslySetInnerHTML={{ __html: word.yTerm }} />
                          {'m'+id+'_y1' in this.props.audioFiles && !this.props.printView ?
                            <Icon onClick={()=>this.repeatAudio('m'+id+'_y1')} circular style={{marginLeft:'10px',fontSize:(window.innerWidth < 480 ? '12px' : '14px'),color:'#969696',cursor:'pointer'}} name='volume up' />
                            :
                            null
                          }
				              </div>
                    </Grid.Column>
						      </Grid.Row>

                    {this.state.currentPage == '10' ?
                      <Grid.Row style={{paddingTop:'6px',paddingBottom:'16px',fontSize:(window.innerWidth < 480 ? '13px' : '15px'),wordWrap:'break-word',}}columns={2}>
                        <Grid.Column style={{padding:(window.innerWidth < 480 ? '0rem 0.5rem' : '0rem 1rem')}}>
                        {word.eDesc.split('?').map((desc,descindex)=>
                          <div style={{padding:'5px 0px'}}>
                            <span>{desc+(descindex != word.eDesc.split('?').length-1 ? '?' : '')}</span>
                            {'m'+id+'_eq'+(descindex+1).toString() in this.props.audioFiles && !this.props.printView ?
                              <Icon onClick={()=>this.repeatAudio('m'+id+'_eq'+(descindex+1).toString())} style={{marginLeft:(window.innerWidth < 480 ? '5px' : '10px'),fontSize:(window.innerWidth < 480 ? '13px' : '14px'),color:'#a198a8',cursor:'pointer'}} name='volume up' />
                              :
                              null
                            }                            
                          </div>
                        )}
                        </Grid.Column>
                        <Grid.Column style={{padding:(window.innerWidth < 480 ? '0rem 0.5rem' : '0rem 1rem')}}>
                        {word.yDesc.split('?').map((yDesc,ydescindex)=>
                          <div style={{padding:'5px 0px'}}>
                            <span>{yDesc+(ydescindex != word.yDesc.split('?').length-1 ? '?' : '')}</span>
                            {'m'+id+'_yq'+(ydescindex+1).toString() in this.props.audioFiles && !this.props.printView ?
                              <Icon onClick={()=>this.repeatAudio('m'+id+'_yq'+(ydescindex+1).toString())} style={{marginLeft:(window.innerWidth < 480 ? '5px' : '10px'),fontSize:(window.innerWidth < 480 ? '13px' : '14px'),color:'#a198a8',cursor:'pointer'}} name='volume up' />
                              :
                              null
                            }    
                          </div>                    
                        )}
                        </Grid.Column>
                      </Grid.Row>
                      :
                      <Grid.Row style={{paddingTop:'6px',paddingBottom:'16px',fontSize:(window.innerWidth < 480 ? '13px' : '15px'),wordWrap:'break-word'}}columns={2}>
                        <Grid.Column style={{padding:(window.innerWidth < 480 ? '0rem 0.5rem' : '0rem 1rem')}}>
                        <div>
                          {word.eDesc.length > previewCharLimit && dopreview?
                            <span>{word.eDesc.substring(0,previewCharLimit)}<span style={{color:'grey'}}>{'...'}</span></span>
                            :
                            <div dangerouslySetInnerHTML={{ __html: word.eDesc }} />
                          }                      
                        </div>
                        </Grid.Column>
                        <Grid.Column style={{padding:(window.innerWidth < 480 ? '0rem 0.5rem' : '0rem 1rem')}}>
                        <div>
                          {word.yDesc.length > previewCharLimit && dopreview ?
                            <span>{word.yDesc.substring(0,previewCharLimit)}<span style={{color:'grey'}}>{'...'}</span></span>
                            :
                            <div dangerouslySetInnerHTML={{ __html: word.yDesc }} />
                          }   
                        </div>                    
                        </Grid.Column>
                      </Grid.Row>
                    }

                  {'eNotes' in word && word['eNotes'].trim().length > 0 ?
                    <Grid.Row style={{paddingTop:'6px',paddingBottom:'16px',fontSize:(window.innerWidth < 480 ? '13px' : '15px'),wordWrap:'break-word'}}columns={2}>
                      <Grid.Column>
                      <div>
                        {word.eNotes.length > previewCharLimit && dopreview?
                          <span>{word.eNotes.substring(0,previewCharLimit)}<span style={{color:'grey'}}>{'...'}</span></span>
                          :
                          <div dangerouslySetInnerHTML={{ __html: word.eNotes }} />
                        }                      
                      </div>
                      </Grid.Column>
                      <Grid.Column>
                      <div>
                        {word.yNotes.length > previewCharLimit && dopreview ?
                          <span>{word.yNotes.substring(0,previewCharLimit)}<span style={{color:'grey'}}>{'...'}</span></span>
                          :
                          <div dangerouslySetInnerHTML={{ __html: word.yNotes }} />
                        }   
                      </div>                    
                      </Grid.Column>
                    </Grid.Row>
                    :
                    null
                  }


                  {index in this.state.activeAudioIndex ?
                    <Grid.Row columns={2}>
                      <Grid.Column>
                        {'m'+id+'_e2' in this.props.audioFiles && !this.props.printView ?
                          <div>
                            <audio controls style={{width:'-webkit-fill-available',height:40}} src={API_URL + "/aijaudiolibrary/"+'m'+id+'_e2'} />
                          </div>
                          :
                          null
                        }                        

                      </Grid.Column>
                      <Grid.Column>
                        {'m'+id+'_y2' in this.props.audioFiles && !this.props.printView ?
                          <div>
                            <audio controls style={{width:'-webkit-fill-available',height:40}} src={API_URL + "/aijaudiolibrary/"+'m'+id+'_y2'} />
                          </div>
                          :
                          null
                        }    
                      </Grid.Column>
                    </Grid.Row>
                    :
                    null
                  }

                  {false && index in this.state.activeAudioIndex ?
                    <Grid.Row columns={(window.innerWidth < 480 ? 1 : 2)}>
                    {window.innerWidth < 480 ? 
                      null
                      :
                      <Grid.Column />
                    }
                    <Grid.Column>
                    <div style={{display:'flex',lineHeight:'21px',fontSize:(window.innerWidth < 480 ? '13px' : '15px')}}>
                      <div style={{flex:3,paddingRight:'6px'}}>
                        <div>
                        <span style={{fontWeight:'500'}}>{'Translator: '}</span>
                        </div>
                        <div>
                        <span style={{fontWeight:'500'}}>{'Speaker: '}</span>
                        </div>                
                      </div>
                      <div style={{flex:13}}>
                        <div>
                        <span>{'Veronica Kaganak'}</span>
                        </div>
                        <div>
                        <span>{'Veronica Kaganak'}</span>
                        </div>
                      </div>
                      <div style={{flex:1}} />
                    </div>
                    </Grid.Column>
                    </Grid.Row>
                    :
                    null
                  }
                  {('m'+id+'_e2' in this.props.audioFiles  || 'm'+id+'_y2' in this.props.audioFiles) && !this.props.printView ?
                    <Grid.Row style={{paddingTop:0,fontSize:'14px',justifyContent:'flex-end'}}>
                    <Button style={{marginRight:'14px'}} onClick={()=>this.setActiveAudioIndex(word,index)} basic>
                    <div style={{color:'#A2A2A2'}}>
                    {'More Audio'}
                    {index in this.state.activeAudioIndex ?
                      <Icon style={{paddingLeft:'5px'}} name='chevron up' />
                      :
                      <Icon style={{paddingLeft:'5px'}} name='chevron down' />
                    }                    
                    </div>
                    </Button>
                    </Grid.Row>
                    :
                    <Grid.Row style={{padding:9}} />
                  }
                </Grid>
						    })}
          </div>

        <List>
      	<div>

        <Grid style={{fontSize:'15px'}}>
        <Grid.Row style={{marginTop:14,marginBottom:14}}>
        <Grid.Column>
        <Citation />
        </Grid.Column>
        </Grid.Row>
        </Grid>

        </div>

            </List>






        </Grid.Column>
        </Grid.Row>
      </Grid>


			</div>
		);
	}
}
export default NewPage;